import { Controller } from "@hotwired/stimulus"
import { Chart, DoughnutController, ArcElement, Tooltip, Legend } from "chart.js"

Chart.register(DoughnutController, ArcElement, Tooltip, Legend)

export default class extends Controller {
  static values = { data: Object }

  connect() {
    const { labels, values, colors } = this.dataValue

    new Chart(this.element, {
      type: "doughnut",
      data: {
        labels,
        datasets: [{ data: values, backgroundColor: colors, borderWidth: 2 }]
      },
      options: {
        responsive: true,
        cutout: "65%",
        plugins: {
          legend: { position: "bottom", labels: { padding: 12, font: { size: 11 } } },
          tooltip: {
            callbacks: {
              label: ctx => {
                const total = ctx.dataset.data.reduce((a, b) => a + b, 0)
                const pct = total > 0 ? Math.round(ctx.parsed * 100 / total) : 0
                return ` ${ctx.label}: ${ctx.parsed} (${pct}%)`
              }
            }
          }
        }
      }
    })
  }
}
